import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Link,
} from "react-router-dom";
import MainScreen from "./components/MainScreen/MainScreen";
import MatchUpdates from "./components/MatchUpdates/MatchUpdates";
import Login from "./components/Login/Login";
import SignUp from "./components/SignUp/SignUp";
import AccountStatus from "./components/AccountStatus/AccountStatus";
import PlaceBet from "./components/PlaceBet/index";
// import AfterLogin from './components/AfterLogin/AfterLogin';
import AccountStatement from "./components/AccountStatement/AccountStatement";
import Deposit from "./components/Deposit/Deposit";
import AddWithdrawMethod from "./components/Withdraw/AddWithdrawMethod";
import MyMarkets from "./components/MyMarkets/MyMarkets";
import CricketList from "./components/CricketList/CricketList";
import FootballList from "./components/FootballList/FootballList";
import TennisList from "./components/TennisList/TennisList";
import HorseRacingList from "./components/HorseRacingList/HorseRacingList";
import GrayHoundRacingList from "./components/GrayHoundRacingList/GrayHoundRacingList";
import IndianCardGamesList from "./components/IndianCardGamesList/IndianCardGamesList";
import OpenBets from "./components/OpenBets/OpenBets";
import ProfitAndLoss from "./components/ProfitAndLoss/ProfitAndLoss";
import ChangePassword from "./components/ChangePassword/ChangePassword";
import Settings from "./components/Settings/Settings";
import Profile from "./components/Profile/Profile";
import { FaN } from "react-icons/fa6";
import FancyMarket from "./components/FancyMarket/FancyMarket";
import ProfitAndLoss2 from "./components/ProfitAndLoss/ProfitAndLoss2";
import ProfitAndLoss3 from "./components/ProfitAndLoss/ProfitAndLoss3";
import Rules from "./components/Rules/Rules";
import AddWithdrawDetails from "./components/AddWithdrawDetails/AddWithdrawDetails";
import BankForm from "./components/AddWithdrawDetails/BankForm";
import PaytmForm from "./components/AddWithdrawDetails/PaytmForm";
import UpiForm from "./components/AddWithdrawDetails/UpiForm";
import PhonepeForm from "./components/AddWithdrawDetails/PhonepeForm";
import GpayForm from "./components/AddWithdrawDetails/GpayForm";
import Empty from "./components/EmptyDiv/Empty";
import ReferAndEarn from "./components/ReferAndEarn/ReferAndEarn";
import { TimeProvider } from "./components/TimeContext/TimeContext";
import PlaceBetSuccessfull from "./components/PlaceBetSuccesfull/PlaceBetSuccessfull";
import ScrollCasino from "./components/ScrollCasino/ScrollCasino";
import UpcomingEvents from "./components/UpcomingEvents/UpcomingEvents";
import PrivateRoute from "./utils/PrivateRoute";
import { AuthProvider } from "./components/AuthContext";
import { WebSocketContext, socket } from "./components/Context/websocket";
import ProfitLossEvents from "./components/profit-loss-events/index";
import ProfitLossEventMarkets from "./components/profit-loss-event-markets/index";
import ProfitLossBetHistory from "./components/profit-loss-bet-history/index";
import EzugiLobby from "./components/ezugiLobby/index";
import EzugiAll from "./components/ezugiLobby/ezugiAll/index";
import EzugiMac88 from "./components/ezugiLobby/ezugiMac88/index";
import EzugiFunGames from "./components/ezugiLobby/ezugiFunGames";
import EzugiTurboGames from "./components/ezugiLobby/ezugiTurboGames/index";
import EzugiCasino from "./components/ezugiLobby/ezugiCasino";
import EzugiSpribeCasino from "./components/ezugiLobby/ezugiSpribeCasino";
import EzugiJili from "./components/ezugiLobby/ezugiJili";
import EzugiSmartSoft from "./components/ezugiLobby/ezugiSmartSoft";
import EzugiKingMaker from "./components/ezugiLobby/ezugiKingmaker";
import EzugiBetGamesTv from "./components/ezugiLobby/ezugiBetGamesTv";
import EzugiCrashGames from "./components/ezugiLobby/ezugiCrashGames";
import EzugiEvolution from "./components/ezugiLobby/ezugiEvolution";
import News from "./components/News/news";
import MainLayout from "./utils/MainLayout";
import InPlay from "./components/InPlay/InPlay";
import AllGamesLobby from "./components/Lobby/AllGamesLobby";
import Withdraw from "./components/Withdraw/Withdraw";
import ProfitLossEventMarketsAll from './components/profit-loss-event-markets-all'


function App() {
  return (
    <AuthProvider>
      <TimeProvider>
        <Router>
          <WebSocketContext.Provider value={socket}>
            <Routes>
              <Route
                path="matchupdates/:event_id/:is_inplay"
                element={<MatchUpdates />}
              />
              <Route path="/" element={<MainScreen />} />
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <MainLayout />
                  </PrivateRoute>
                }
              >
                <Route path="all-games-lobby" element={<AllGamesLobby />} />

                <Route path="upcomingevents" element={<UpcomingEvents />} />
                <Route path="accountstatus" element={<AccountStatus />} />
                <Route path="placebet" element={<PlaceBet />} />
                <Route path="accountstatement" element={<AccountStatement />} />
                <Route path='/profit-loss-event-market-all' element={<ProfitLossEventMarketsAll />} />
                <Route path="deposit" element={<Deposit />} />
                {/* <Route path="withdraw" element={<Withdraw />} /> */}
                <Route path="withdraw" element={<Withdraw />} />
                <Route path="add-withdraw-method" element={<AddWithdrawMethod />} />
                <Route path="mymarkets" element={<MyMarkets />} />
                <Route path="inPlay" element={<InPlay />} />
                <Route path="cricketlist" element={<CricketList />} />
                <Route path="football-list" element={<FootballList />} />
                <Route path="tennislist" element={<TennisList />} />
                <Route path="horseracinglist" element={<HorseRacingList />} />
                <Route
                  path="grayhoundracinglist"
                  element={<GrayHoundRacingList />}
                />
                <Route
                  path="indiancardgameslist"
                  element={<IndianCardGamesList />}
                />
                <Route path="openbets" element={<OpenBets />} />
                <Route path="profitandloss" element={<ProfitAndLoss />} />

                <Route
                  path="profit-loss-event/:event_type_id/:from_date/:to_date"
                  element={<ProfitLossEvents />}
                />
                <Route
                  path="profit-loss-event-market/:match_id/:from_date/:to_date"
                  element={<ProfitLossEventMarkets />}
                />
                {/* <Route
                  path="profit-loss-bet-history/:match_id/:market_id/:from_date/:to_date"
                  element={<ProfitLossBetHistory />}
                /> */}
                {/* <Route
                  path="wco-casino-profit-loss-bet-history/:event_type_id/:market_id/:from_date/:to_date"
                  element={<ProfitLossBetHistory />}
                /> */}
                <Route path='/profit-loss-bet-history/:match_id/:market_name/:market_id/:from_date/:to_date' element={<ProfitLossBetHistory />} />

                <Route
                  path="wco-casino-profit-loss-bet-history/:event_type_id/:market_id/:from_date/:to_date"
                  element={<ProfitLossBetHistory />}
                />
                <Route path="changepassword" element={<ChangePassword />} />
                <Route path="settings" element={<Settings />} />
                <Route path="profile" element={<Profile />} />
                <Route path="fancymarket" element={<FancyMarket />} />
                <Route path="profitandloss2" element={<ProfitAndLoss2 />} />
                <Route path="profitandloss3" element={<ProfitAndLoss3 />} />
                <Route path="rules" element={<Rules />} />
                <Route
                  path="addwithdrawdetails"
                  element={<AddWithdrawDetails />}
                />
                <Route path="bankform" element={<BankForm />} />
                <Route path="paytmform" element={<PaytmForm />} />
                <Route path="upiform" element={<UpiForm />} />
                <Route path="phonepeform" element={<PhonepeForm />} />
                <Route path="gpayform" element={<GpayForm />} />
                <Route path="emptydiv" element={<Empty />} />
                <Route path="referandearn" element={<ReferAndEarn />} />
                <Route
                  path="placebetsuccessfully"
                  element={<PlaceBetSuccessfull />}
                />
                <Route path="scrollcasino" element={<ScrollCasino />} />
                <Route path="ezugiLobby" element={<EzugiLobby />} />
                <Route path="ezugiAll" element={<EzugiAll />} />
                <Route path="ezugiMac88" element={<EzugiMac88 />} />
                <Route path="ezugiFunGames" element={<EzugiFunGames />} />
                <Route path="ezugiCrashGames" element={<EzugiCrashGames />} />
                <Route path="ezugiTurboGames" element={<EzugiTurboGames />} />
                <Route path="ezugiCasino" element={<EzugiCasino />} />
                <Route
                  path="ezugiSpribeCasino"
                  element={<EzugiSpribeCasino />}
                />
                <Route path="ezugiJili" element={<EzugiJili />} />
                <Route path="ezugiSmartSoft" element={<EzugiSmartSoft />} />
                <Route path="ezugiKingMaker" element={<EzugiKingMaker />} />
                <Route path="ezugiBetGamesTv" element={<EzugiBetGamesTv />} />
                <Route path="ezugiEvolution" element={<EzugiEvolution />} />
                <Route path="news" element={<News />} />
              </Route>
            </Routes>
          </WebSocketContext.Provider>
        </Router>
      </TimeProvider>
    </AuthProvider>
  );
}
// };

export default App;
